<div class="zmovo-main dark-bg video-landing-page" >
  <div class="zmovo-trailor-slides">
      <video class="video-js player-height-width" data-setup='{"controls": false, "autoplay": false, "loop": true, "preload": "auto", "muted": true}'></video>
  </div>
  <div class="video-landing">
      <img src="../../../assets/image/logo.png">
      <button type="submit" (click)="EnterWebsite()">Enter the Website</button>
  </div>
</div>
